import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/button';
import {ESCAPE, RETURN} from 'common/constants';
import {t} from 'common/utils/translation-util';
import './index.scss';

export default class ModalFooter extends React.Component {
  static propTypes = {
    cancelButtonProps: PropTypes.object,
    children: PropTypes.any,
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    saveButtonProps: PropTypes.object,
  };

  static defaultProps = {
    cancelButtonProps: {
      children: t('Cancel'),
    },
    saveButtonProps: {
      children: t('Save'),
      type: 'green',
    },
  };

  constructor() {
    super();
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  getCancelButtonClassName(saveButtonProps) {
    return [
      'ModalFooter-cancel',
      saveButtonProps && saveButtonProps.withIcon
        ? 'ModalFooter-cancel--buttonWithIcon'
        : '',
    ]
      .filter((datum) => datum)
      .join(' ');
  }

  getCancelButtonProps(cancelButtonProps, onCancel, cancelButtonClassName) {
    return {
      ...cancelButtonProps,
      onClick: onCancel,
      className: cancelButtonClassName,
    };
  }

  getCancelButton(cancelButtonProps) {
    let element = 'span';
    if (cancelButtonProps.useButton) {
      element = Button;
      delete cancelButtonProps.useButton;
    }
    return React.createElement(element, cancelButtonProps);
  }

  getSaveButtonClassName(saveButtonProps) {
    return [
      'ModalFooter-save',
      saveButtonProps && saveButtonProps.className
        ? saveButtonProps.className
        : '',
    ]
      .filter((datum) => datum)
      .join(' ');
  }

  getSaveButtonProps(saveButtonProps, onSave, saveButtonClassName) {
    return {
      ...saveButtonProps,
      onClick: onSave,
      className: saveButtonClassName,
    };
  }

  render() {
    const cancelButtonClassName = this.getCancelButtonClassName(
      this.props.saveButtonProps,
    );
    const cancelButtonProps = this.getCancelButtonProps(
      this.props.cancelButtonProps,
      this.props.onCancel,
      cancelButtonClassName,
    );
    const saveButtonClassName = this.getSaveButtonClassName(
      this.props.saveButtonProps,
    );
    const saveButtonProps = this.getSaveButtonProps(
      this.props.saveButtonProps,
      this.props.onSave,
      saveButtonClassName,
    );

    return (
      <div className='ModalFooter'>
        <div className='ModalFooter-content'>
          {this.props.children}
          <div className='ModalFooter-button-group'>
            {this.props.onCancel
              ? this.getCancelButton(cancelButtonProps)
              : null}
            {this.props.onSave ? <Button {...saveButtonProps} /> : null}
          </div>
        </div>
      </div>
    );
  }

  handleKeyDown(event) {
    if (!this.props.isOpen) {
      return;
    }

    switch (event.keyCode) {
      case ESCAPE:
        if (this.props.onCancel) {
          this.props.onCancel();
        }
        break;
      case RETURN:
        if (this.props.onSave) {
          this.props.onSave();
        }
        break;
      default:
        break;
    }
  }
}
